import { Injectable } from "@angular/core";
import { Observable, Subject, Subscription, firstValueFrom, take } from "rxjs";
import { EstatusJSON } from "../../models/EstatusJSON";
import { PermissionAPIService } from "../API/PermissionAPI.service";

@Injectable({
  providedIn: "root",
})
export class PermissionsService {
  configUrl: string;

  constructor(
    private permissionService: PermissionAPIService,
  ) {
  }

  GetList(role:string = ""): Observable<EstatusJSON> {
    return this.permissionService.GetList(role);
  }
}
